import { createContext } from 'react';

export interface SignInCredentials {
  email: string;
  password: string;
}

export interface System {
  id: string;
  name: string;
  description: string;
  token: string;
  base_url: string;
}

export interface Entity {
  id: string;
  name: string;
  description?: string;
  cnpj?: string;
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  profile_picture?: string;
  phone_number?: string;
  cpf?: string;
  last_login?: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  systems: System[];
  entities: Entity[];
}

interface AuthContextData {
  user: User | null;
  authenticated: boolean;
  loading: boolean;
  /**
   * Aceita também uma url opcional para redirecionar após login.
   */
  signIn: (data: SignInCredentials, redirectUrl?: string) => Promise<void>;
  signOut: () => void;
  refreshUserToken: () => void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export default AuthContext;